import React from 'react';
import styles from '../../styles/countryadmissionsday.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import Button from 'react-bootstrap/Button';
import router from 'next/router';
import useZipmeLink from '../../hooks/useZipmeLink';
import { isFrappeOrJotFormClass } from '../../utils/helpers';
interface Props {
  whyChoosedata: any;
  jotformId: string;
  externalLink : any;
}

const WhyChoose: React.FC<Props> = ({ whyChoosedata, jotformId, externalLink }) => {
  const { zipmeLink, generateLink } = useZipmeLink();
  return (
    <>
      <div
        className={styles.studentSpecialOffer}
        style={{ backgroundColor: '#EFEFFA' }}
      >
        <Container>
          <Row className={styles.centerAlign} >
            <Col xl={6} lg={6} md={6} sm={12} className={styles.stuImgtext}>
              <div className={styles.heading}>
                <h2>{whyChoosedata.sectionTitle}</h2>
              </div>
              <div className={styles.OffersContent}>
                <ul className={styles.ulli}>
                  {whyChoosedata?.offers?.length > 0 &&
                    whyChoosedata.offers.map(
                      (offerabt: string, ind: number) => {
                        return <li key={ind}>{offerabt}</li>;
                      }
                    )}
                </ul>
              </div>
              <div className={styles.anchor}>
                <Button onClick={()=>{
                  !jotformId && generateLink(externalLink);
                }} className={`${styles.btnReg} ${jotformId ?` ${isFrappeOrJotFormClass(jotformId)}` : '' }` }>
                  Register Now
                </Button>
                <script
                  dangerouslySetInnerHTML={{
                    __html: `window.lintrk('track', { conversion_id: 6870956 });`,
                  }}
                />
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className={styles.whystuImg}>
              <div>
                <CustomImage
                  src={
                    whyChoosedata?.sectionImage ||
                    '/images/admissionsday/whychoose-kc.svg'
                  }
                  width={207}
                  height={207}
                  className={styles.cardImg}
                  layout='responsive'
                  alt='University-Representative.png'
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default WhyChoose;